<template>
  <div class="icon-info-card-skeleton">
    <PSkeleton height="64px" shape="circle" width="64px" />
    <div class="icon-info-card-skeleton__info">
      <PSkeleton height="18px" :width="titleWidth" />
      <PSkeleton height="16px" :width="descriptionWidth" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PSkeleton } from "@solvari/components";

withDefaults(
  defineProps<{
    descriptionWidth?: string;
    titleWidth?: string;
  }>(),
  {
    titleWidth: "70px",
    descriptionWidth: "130px",
  },
);
</script>

<style scoped lang="postcss">
.icon-info-card-skeleton {
  @apply flex items-center gap-2;

  &__info {
    @apply flex flex-col gap-2;
  }
}
</style>
